import { Container } from "@mui/material";
import { Button } from "@material-ui/core";

function InspectionEnd() {
  return (
    <Container className="center">
      <div>
        <h2>検査が終了しました</h2>
        <div className="text-center">
          {
              window.opener ||
              (
                window === window.top &&
                window.history.length <= 1
              ) ? (
                <Button
                  style={{ color: "#fff", backgroundColor: "#1e88e5" }}
                  onClick={() => window.close()}
                >
                  閉じる
                </Button>
              ) : 'このページを閉じてください。'
          }
        </div>
      </div>
    </Container>
  );
}

export default InspectionEnd;
